import React, { Dispatch, SetStateAction, useEffect } from 'react'
import { useForm, FormProvider } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"

import { Typography, Box, styled, sx, Button } from 'shared-components/material/core'
import { TextInput } from 'shared-components/inputs'
import { CenteredForm } from 'shared-components/layout'

const ProcessingOptionsContainer = styled(Box)((
    sx({
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        width: '100%'
    })
))

const schema = yup.object({
    customMessage: yup.string().required('Custom Message is required'),
}).required()

type FormData = {
    customMessage: string, 
}

type CustomMessageProps = {
    customMessage: string,
    passSetupData: (data: FormData) => void,
    setOpenPrintEmailModal: Dispatch<SetStateAction<boolean>>,
}

export default function CustomMessage({
    customMessage,
    passSetupData,
    setOpenPrintEmailModal
}: CustomMessageProps) {

    const methods = useForm({
        defaultValues: { //create empty init values to avoid uncontrolled to controlled warning
            customMessage: '',
        },
        resolver: yupResolver(schema),
    })

    const { handleSubmit, setValue, formState: { errors } } = methods


    useEffect(() => {
        if (customMessage) {
            setValue('customMessage', customMessage)
        }
    }, [customMessage])

    const onSubmit = (data: FormData) => {
        passSetupData(data)
    }

    return (
        <ProcessingOptionsContainer>
            <CenteredForm>
                <FormProvider {...methods}>
                    <Typography variant="h5" component="h2" sx={{ mt: 2}}>
                        Email Setup
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 2, maxWidth: '700px'}}>
                        Your exhibit set data will be sent directly to the printer. Please provide any additional instructions you would like to provide to the printer below. 
                    </Typography>
                    <>
                        <TextInput
                            name="customMessage"
                            label="Printer Instructions"
                            required
                            error={errors.customMessage !== undefined ? true : false }
                            errorMessage={errors.customMessage ? errors.customMessage.message : undefined}
                            multiline
                            rows={10}
                        />
                    </>
                </FormProvider>
            </CenteredForm>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                pt: 2,
                width: '100%'
            }}>
                <Button
                    onClick={() => setOpenPrintEmailModal(false)}
                    sx={{ mr: 1 }}
                >
                    Back
                </Button>
                <Button 
                    onClick={handleSubmit(onSubmit)}
                    variant="contained"
                >
                    Next
                </Button>
            </Box>
        </ProcessingOptionsContainer>
    )
}
